var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":_vm.type,"disabled":_vm.isDisabled},on:{"click":_vm.clicked}},[(!_vm.title)?[(_vm.loading)?_c('i',{staticClass:"fa fa-refresh fa-spin fa-fw"}):_vm._t("default")]:_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentTitle)}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }